// library
import { ArSymbol } from '@aceroll/core/library';

// engine
import { soundService } from '@aceroll/core';

// services
import { scatterCounterService } from '../../../services/scatter-counter-service';

export class Bonus extends ArSymbol {

	constructor() {
		super(...arguments);
	}

	async land() {
		scatterCounterService.add(this.id);

		const { sounds } = this.config.default;

		if (sounds.land) {
			soundService.play(sounds.land);
		}

		return super.land();
	}

	async win() {
		const { sounds } = this.config.default;

		if (sounds.win) {
			soundService.play(sounds.win);
		}

		return super.win();
	}
}
